var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fragmentContent)?_c(_vm.fragmentContent.renderTag,{tag:"component",attrs:{"content":_vm.fragmentContent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }